<template>
  <div class="equity-wrapper">
    <!-- 开发者等级说明 -->
    <div class="level-rule">
      <span class="tip" @click="handleShowRule">
        开发者等级说明<i class="ques-icon"></i>
      </span>
    </div>
    <!-- 轮播 -->
    <div class="level-banner">
      <van-swipe
        class="my-swipe"
        indicator-color="white"
        @change="handleChangeSwipe"
      >
        <van-swipe-item
          v-for="(item, index) of levelList"
          :key="item.id"
          class="my-swipe-item"
          :class="item.id"
        >
          <template v-if="levelData">
            <div class="level-num">
              开发者Lv {{ levelData.config[index].l }}
            </div>
            <div class="level-text">
              <div class="line">
                <div class="line-holder"></div>
              </div>
              <div class="text">
                <span v-if="levelData.score >= levelData.config[index].s">
                  信用分{{ levelData.score }}
                </span>
                <span v-else>
                  信用分{{ levelData.score }}，再获取{{
                    levelData.config[index].s - levelData.score
                  }}信用分升级
                </span>
              </div>
            </div>
            <div
              v-if="levelData.score < levelData.config[index].s || !isDeveloper"
              class="lock-mask"
            >
              <span class="text">未解锁</span>
            </div></template
          >
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 等级权益 -->
    <div class="level-detail">
      <div class="title">{{ currentLevel.name }}等级权益</div>
      <div class="level-detail-list">
        <div class="level-detail-item">
          <i class="icon ewcdsl"></i>
          <p class="type">额外存档数量</p>
          <div class="tip">
            <p>增加{{ currentLevel.ewcdsl }}个</p>
          </div>
        </div>
        <div class="level-detail-item">
          <i class="icon ffdsgn"></i>
          <p class="type">付费打赏功能</p>
          <div class="tip">
            <p>{{ currentLevel.ffdsgn }}</p>
          </div>
        </div>
        <div class="level-detail-item">
          <i class="icon xbsr"></i>
          <p class="type">贡献点收入</p>
          <div class="tip">
            <p>{{ currentLevel.xbsr }}</p>
          </div>
        </div>
        <div class="level-detail-item">
          <i class="icon mndsr"></i>
          <p class="type">迷你豆收入</p>
          <div class="tip">
            <p>{{ currentLevel.mndsr }}</p>
          </div>
        </div>
        <div class="level-detail-item">
          <i class="icon sjfxptqx"></i>
          <p class="type">数据分析平台权限</p>
          <div class="tip">
            <p>{{ currentLevel.sjfxptqx }}</p>
          </div>
        </div>
        <div class="level-detail-item">
          <i class="icon ngsdsyqx"></i>
          <p class="type">内购商店使用权限</p>
          <div class="tip">
            <p>可售卖物品数量：{{ currentLevel.ngsdsyqx[0] }}</p>
            <p>迷你币价格范围：0~{{ currentLevel.ngsdsyqx[1] }}</p>
            <p>迷你豆价格范围：0~{{ currentLevel.ngsdsyqx[2] }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 成为开发者 -->
    <a v-if="!isDeveloper" :href="registerUrl" target="_blank" class="dev-btn">
      成为开发者
    </a>
    <!-- 开发者等级明细 -->
    <van-popup
      v-model="isRuleVisible"
      closeable
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div class="rule-wrapper">
        <div class="title">开发者等级说明</div>
        <div class="q-group">
          <p class="q">Q：什么是开发者等级？</p>
          <p class="a">
            A：开发者等级是根据开发者的信用值来评定的，开发者可以通过达成一系列的加分任务（里程碑），晋升到更高级别的开发者，获取更高的收益分成、更多的存档位置、更强的付费编辑功能。
          </p>
        </div>
        <div class="q-group">
          <p class="q">Q：怎样获得信用值？</p>
          <p class="a">
            A：地图被下载、评论、进入（联机房间）；每张地图根据标准制定了多档里程碑，达成后即可获得开发者信用值，每个地图的相同里程碑不能重复获得（地图下架，数据被清空并不会减少信用值）
          </p>
        </div>
        <div class="q-group">
          <p class="q">Q：哪些情况会让信用值减少？</p>
          <p class="a">
            A：作品内容里含有国家禁止的内容，会扣分且下架作品，严重的直接封号、禁止账号资金并永远列入黑名单；当出现违规行为时会出现扣分，包括但不限于内容低俗恶俗、黑科技、盗图行为、内购道具与实际效果不符、欺诈消费者
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getAccEquity } from '@/api/account';
import { createRegisterUrl } from '@/utils';
import { mapState } from 'vuex';

export default {
  created() {
    this.init();
  },
  data() {
    const xbsr = '内购收入利润的70%';
    const mndsr = '内购收入利润的100%';

    return {
      isLoading: false,
      isRuleVisible: false,
      registerUrl: createRegisterUrl(),

      isDeveloper: false,
      levelData: null,

      // 当前 swiper 索引
      currentSwipeIndex: 0,
      // 等级信息
      levelList: [
        {
          id: 'stardust',
          name: '星尘',
          ewcdsl: 40,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [10, 99, 199],
        },
        {
          id: 'nebula',
          name: '星云',
          ewcdsl: 50,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [20, 99, 299],
        },
        {
          id: 'star',
          name: '恒星',
          ewcdsl: 65,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [30, 199, 499],
        },
        {
          id: 'giant',
          name: '红巨星',
          ewcdsl: 90,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [50, 299, 999],
        },
        {
          id: 'superstar',
          name: '超巨星',
          ewcdsl: 110,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [80, 399, 2999],
        },
        {
          id: 'supernova',
          name: '超新星',
          ewcdsl: 140,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [100, 499, 5999],
        },
        {
          id: 'blackhole',
          name: '黑洞',
          ewcdsl: 190,
          ffdsgn: '开启',
          xbsr,
          mndsr,
          sjfxptqx: '开启',
          ngsdsyqx: [150, 599, 9999],
        },
      ],
    };
  },
  computed: {
    ...mapState(['developerInfo']),
    currentLevel() {
      return this.levelList[this.currentSwipeIndex];
    },
  },
  methods: {
    init() {
      const { state } = this.developerInfo;
      if (state == 0 || state == 3) {
        this.levelData = {
          config: [
            { l: 1, s: 0 },
            { l: 2, s: 60 },
            { l: 3, s: 500 },
            { l: 4, s: 2500 },
            { l: 5, s: 12500 },
            { l: 6, s: 62500 },
            { l: 7, s: 250000 },
          ],
          score: 0,
        };
      } else {
        this.fetchGetEquity();
        this.isDeveloper = true;
      }
    },
    // 获取开发者信用分及等级配置
    async fetchGetEquity() {
      this.isLoading = true;
      try {
        const res = await getAccEquity();
        this.isLoading = false;
        this.levelData = res.data;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    handleShowRule() {
      this.isRuleVisible = true;
    },
    handleChangeSwipe(index) {
      this.currentSwipeIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.rule-wrapper {
  padding: 20px 32px;
  line-height: 40px;

  .title {
    padding: 20px 0;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }

  > p {
    padding-bottom: 20px;
    font-size: 26px;
  }

  .q-group {
    color: #595959;
    padding-bottom: 30px;
  }
}
.level-rule {
  height: 56px;
  line-height: 56px;
  color: #8c8c8c;
  text-align: right;

  .tip {
    display: inline-block;
    height: 100%;
  }

  .ques-icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-left: 16px;
    background: url(~@/assets/images/question-circle-o@2x.png) no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
  }
}

// 轮播图片名称
// TODO - less 用 each + background-image 时出现未知错误。暂时手写
@banners: stardust, nebula, star, giant, superstar, supernova, blackhole;

.level-banner {
  overflow: hidden;
  border-radius: 8px;
  .my-swipe-item {
    height: 207px;
    background-size: 100%;

    &.stardust {
      background-image: url(~@/assets/images/ico_stardust.png);
    }
    &.nebula {
      background-image: url(~@/assets/images/ico_nebula.png);
    }
    &.star {
      background-image: url(~@/assets/images/ico_star.png);
    }
    &.giant {
      background-image: url(~@/assets/images/ico_giant.png);
    }
    &.superstar {
      background-image: url(~@/assets/images/ico_superstar.png);
    }
    &.supernova {
      background-image: url(~@/assets/images/ico_supernova.png);
    }
    &.blackhole {
      background-image: url(~@/assets/images/ico_blackhole.png);
    }
  }
  .level-num {
    position: absolute;
    top: 19%;
    left: 22%;
    color: #eee;
  }
  .level-text {
    position: absolute;
    left: 6%;
    bottom: 50px;
    .line {
      width: 260px;
      height: 2px;
      overflow: hidden;
      background-color: rgba(255, 255, 255, 0.2);
      &-holder {
        width: 95px;
        height: 2px;
        background-color: #ffffff;
      }
    }
    .text {
      color: #ffffff;
      padding-top: 5px;
    }
  }
  .lock-mask {
    position: absolute;
    left: 1%;
    top: 2%;
    width: 98%;
    height: 92%;
    background: rgba(25, 33, 41, 0.6);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      padding-left: 32px;
      background: url('~@/assets/images/ico_lock.svg') no-repeat 0 center;
      background-size: 28px auto;
      line-height: 48px;
      color: #ffffff;
    }
  }
}

// icon 名称
// TODO - less 用 each + background-image 时出现未知错误。暂时手写
@icons: ewcdsl, ffdsgn, xbsr, mndsr, sjfxptqx, ngsdsyqx;
.level-detail {
  padding: 30px 0;
  background-color: #fff;
  border-radius: 8px;
  .title {
    font-size: 28px;
    text-align: center;

    &::before,
    &::after {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 30px;
      height: 20px;
      background-size: contain;
      background-repeat: no-repeat;
    }

    &::before {
      margin-right: 18px;
      background-image: url('../../assets/images/img_decorate_l.svg');
    }
    &::after {
      margin-left: 18px;
      background-image: url('../../assets/images/img_decorate_l.svg');
    }
  }
  &-list {
    padding-top: 30px;
    overflow: hidden;
  }
  &-item {
    float: left;
    width: 50%;
    padding-bottom: 30px;
    text-align: center;

    .icon {
      display: inline-block;
      width: 70px;
      height: 70px;
      background-size: contain;
      vertical-align: top;

      &.ewcdsl {
        background-image: url(~@/assets/images/ico_ewcdsl.svg);
      }
      &.ffdsgn {
        background-image: url(~@/assets/images/ico_ffdsgn.svg);
      }
      &.xbsr {
        background-image: url(~@/assets/images/ico_xbsr.svg);
      }
      &.mndsr {
        background-image: url(~@/assets/images/ico_mndsr.svg);
      }
      &.sjfxptqx {
        background-image: url(~@/assets/images/ico_sjfxptqx.svg);
      }
      &.ngsdsyqx {
        background-image: url(~@/assets/images/ico_ngsdsyqx.svg);
      }
    }

    .type {
      padding-top: 8px;
      font-size: 26px;
    }

    .tip {
      padding-top: 2px;
      font-size: 24px;
      color: #8c8c8c;
    }
  }
}
.dev-btn {
  display: block;
  width: 80%;
  height: 70px;
  margin: 30px auto;
  line-height: 70px;
  background: #fd9b21;
  border-radius: 8px;
  color: #fff;
  font-size: 28px;
  text-align: center;
}
</style>
